import { firestoreTimestampToDate, isDate } from "../utils/obejct-diff";
import { Context, ContextMembership } from "./context.data";
import { HuntingDistrict, Outline } from "./hunting-district.dto";
import { NetworkConstants } from "./network.constants";

export const LaboratorySampleStatusIcons = {
    erfasst: 'erfasst',
    unbekannt: 'unbekannt',
    ohneBefund: 'ohneBefund', 
    positiverBefund: 'positiverBefund' 
}

    
export interface ILSExaminations {
    approvalTimestamp?: Date
    checkDate?: Date
    examinationDisease?: String
    examinationMethod?: String
    receiptDate?: Date
    result?: String
    resultValue?: String
}

export interface ILaboratorySample {
    identifier: string
    createdByUserId: string
    gameRecordId: string
    contextId: string
    materialID: string
    huntingDistrictId: string
    type: string
    status: string
    currentLocation: string
    updateTimestamp?: Date
    examinations?:ILSExaminations[]
    result?:string

    hiTierState?:string
    hiTierError?:string
    hiTierErrorCode?:string
    nvState?:string
    nvError?:string
    nvErrorCode?:string
}

export class LaboratorySample {

    public context: Context|ContextMembership|undefined = undefined
    public districts: HuntingDistrict[]|undefined = undefined
    public createdByUserId: string|undefined = undefined
    public identifier: string|undefined = undefined
    public contextId: string|undefined = undefined
    public currentLocation: string|undefined = undefined
    public currentLocationTitle: string|undefined = undefined
    public gameRecordId: string|undefined = undefined
    public huntingDistrictId: string|undefined = undefined
    public huntingDistrictName: string|undefined = undefined
    public materialID: string|undefined = undefined
    public result: string|undefined = undefined
    public status: string|undefined = undefined
    public statusTitle: string|undefined = undefined
    public type: string|undefined = undefined
    public typeTitle: string|undefined = undefined
    public comment: string|undefined = undefined
    public creationDate: Date|undefined = undefined
    public updateTimestamp: Date|undefined = undefined

    public examinations?:ILSExaminations[]|undefined = undefined

    public hiTierState?:string|undefined = undefined
    public hiTierError?:string|undefined = undefined
    public hiTierErrorCode?:string|undefined = undefined
    public nvState?:string|undefined = undefined
    public nvError?:string|undefined = undefined
    public nvErrorCode?:string|undefined = undefined

    constructor(
        additionalContext?: Context|ContextMembership,
        districts?: HuntingDistrict[]
    ) {
        this.context = additionalContext
        this.districts = districts
    }

    setFromAny(element: any) {
        const {
            identifier, 
            contextId, 
            currentLocation,
            createdByUserId,
            currentLocationTitle,
            gameRecordId,
            huntingDistrictId, 
            huntingDistrictName,
            materialID,
            result, 
            status, 
            statusTitle,
            type,
            typeTitle,
            comment,
            creationDate, 
            updateTimestamp,
            examinations, hiTierState, hiTierError, hiTierErrorCode, nvState, nvError, nvErrorCode
        } = element
        // set if only ids are set ...
        if (!typeTitle && this.type) this.typeTitle = this.getTypeTitle()
        if (!statusTitle && this.status) this.statusTitle = this.getStatusTitle()
        if (!currentLocationTitle && this.currentLocation) this.currentLocationTitle = this.getLocationTitle()

        this.createdByUserId = createdByUserId ? createdByUserId : this.createdByUserId
        this.identifier = identifier ? identifier : this.identifier
        this.contextId = contextId ? contextId : this.contextId
        this.currentLocation = currentLocation ? currentLocation : this.currentLocation
        this.currentLocationTitle = currentLocationTitle ? currentLocationTitle : this.currentLocationTitle
        this.gameRecordId = gameRecordId ? gameRecordId : this.gameRecordId
        this.huntingDistrictId = huntingDistrictId ? huntingDistrictId : this.huntingDistrictId
        this.huntingDistrictName = huntingDistrictName ? huntingDistrictName : this.huntingDistrictName
        this.materialID = materialID ? materialID : this.materialID
        this.result = result ? result : this.result
        this.status = status ? status : this.status
        this.statusTitle = statusTitle ? statusTitle : this.statusTitle
        this.type = type ? type : this.type
        this.typeTitle = typeTitle ? typeTitle : this.typeTitle
        this.comment = comment ? comment : this.comment
        this.creationDate = creationDate ? isDate(creationDate) ? creationDate : firestoreTimestampToDate(creationDate) : this.creationDate
        this.updateTimestamp = updateTimestamp ? isDate(updateTimestamp) ? updateTimestamp : firestoreTimestampToDate(updateTimestamp) : this.updateTimestamp
        this.examinations = examinations ? examinations : this.examinations
 
        this.hiTierState = hiTierState ? hiTierState : this.hiTierState
        this.hiTierError = hiTierError ? hiTierError : this.hiTierError
        this.hiTierErrorCode = hiTierErrorCode ? hiTierErrorCode : this.hiTierErrorCode
        this.nvState = nvState ? nvState : this.nvState
        this.nvError = nvError ? nvError : this.nvError
        this.nvErrorCode = nvErrorCode ? nvErrorCode : this.nvErrorCode
    }

    getStatusTitle(): string|undefined {
        if (this.statusTitle) return this.statusTitle
        if (!this.status) return undefined
        const settingRef = NetworkConstants.SETTING_LAB_SAMPLE_STATUS
        const setting = this.context?.settingsMap.get(settingRef)
        if (!this.context || !setting) return this.status ? this.status : undefined
        const quality = setting.values.find(el => el.identifier == this.status)
        if (!quality) return this.status ? this.status : undefined
        return quality.title ? quality.title : this.status ? this.status : undefined
    }

    getLocationTitle() {
        if (this.currentLocationTitle) return this.currentLocationTitle
        if (!this.currentLocation) return undefined
        const settingRef = NetworkConstants.SETTING_LAB_SAMPLE_LOCATION
        const setting = this.context?.settingsMap.get(settingRef)
        if (!this.context || !setting) return this.currentLocation ? this.currentLocation : undefined
        const quality = setting.values.find(el => el.identifier == this.currentLocation)
        if (!quality) return this.currentLocation ? this.currentLocation : undefined
        return quality.title ? quality.title : this.currentLocation ? this.currentLocation : undefined
    }

    getTypeTitle() {
        if (this.typeTitle) return this.typeTitle
        if (!this.type) return undefined
        const settingRef = NetworkConstants.SETTING_LAB_SAMPLE_TYPE
        const setting = this.context?.settingsMap.get(settingRef)
        if (!this.context || !setting) return this.type ? this.type : undefined
        const quality = setting.values.find(el => el.identifier == this.type)
        if (!quality) return this.type ? this.type : undefined
        return quality.title ? quality.title : this.type ? this.type : undefined
    }

    searchFilter(filter: string): boolean {
        const str = `${this.materialID}${this.type}${this.getTypeTitle()}`.toLowerCase()
        return str.includes(filter)
    }

    /**
     * Function for skipping objects and data while deepcopying class.
     * used as optional Input for deepCopy(any, replacerFn)
     * @param key 
     */
    replacerFn(key: string) {
        const list = ["context", "districts"]
        if (list.includes(key)) return false
        else return true
    }
}